import AcademicInfoGroups from './component';
import { TODAY, ALL_GROUPS } from '../routes';

export default () => ({
  path: `(${TODAY})(${ALL_GROUPS})`,
  component: AcademicInfoGroups,
});



// WEBPACK FOOTER //
// ./containers/UserDashboard/AcademicInfo/AcademicInfoGroups/routes.js